import { render, staticRenderFns } from "./order-composition.vue?vue&type=template&id=77d31811"
import script from "./order-composition.vue?vue&type=script&lang=js"
export * from "./order-composition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports